import script from "./NewsWidget.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewsWidget.vue?vue&type=script&lang=ts&setup=true"

import "./NewsWidget.vue?vue&type=style&index=0&id=f767fc36&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f767fc36"]])

export default __exports__